import { TutorResponseCanalPreferido } from '@/api/generated/model';

/**
 * Rótulos do canal de contato.
 *
 * O enum aparece na coluna da tabela, no filtro e no formulário — escrito
 * diferente em cada um seria ruído numa tela de cadastro.
 */
export const CANAIS = Object.values(TutorResponseCanalPreferido).filter(
  (canal): canal is NonNullable<typeof canal> => canal !== null,
);

export const ROTULO_CANAL: Record<string, string> = {
  WHATSAPP: 'WhatsApp',
  EMAIL: 'E-mail',
  TELEFONE: 'Telefone',
};

export function rotuloDoCanal(canal: string | null): string {
  if (!canal) return '—';
  return ROTULO_CANAL[canal] ?? canal;
}
